import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import CenteredCircularProgress from '../../../../lib/designSystem/CircularProgress';
import EnhancedTab from '../../../../lib/designSystem/TabSimulation';
import AccountingEntries from './components/AccountingEntries';
import DailyBook from './components/DailyBook';
import FinancialStatementBook from './components/FinancialStatementBook';
import MajorBook from './components/MajorBook';
import Periods from './components/Periods';
import PurchansesAndSales from './components/PurchansesAndSales';
import ReceiptFees from './components/ReceiptFee';
import TransactionBook from './components/TransactionsBook';

const Accounting: React.FC = () => {
  const { subPage } = useParams<{ page: string; subPage: string }>();
  const navigate = useNavigate();
  const handleNavigation = (index: number) => {
    navigate(`/finance/accounting/${reportsTabs[index].path}`);
  };
  const [companyTabs, setCompanyTabs] = useState<any>([]);
  const [startValue, setStartValue] = useState(0);
  const [loading, setLoading] = useState(true);

  const reportsTabs = [
    {
      label: 'Compras/Ventas',
      component: <PurchansesAndSales />,
      path: 'purchasesAndSales',
    },
    {
      label: 'Honorarios',
      component: <ReceiptFees />,
      path: 'receiptFees',
    },
    {
      label: 'Transacciones',
      component: <TransactionBook />,
      path: 'transactionBook',
    },
    {
      label: 'Libro Diario',
      component: <DailyBook />,
      path: 'dailyBook',
    },
    {
      label: 'Libro mayor',
      component: <MajorBook />,
      path: 'majorBook',
    },
    {
      label: 'Balance',
      component: <FinancialStatementBook />,
      path: 'financialStatementBook',
    },
    {
      label: 'Asientos',
      component: <AccountingEntries />,
      path: 'accountingEntries',
    },
    {
      label: 'Períodos',
      component: <Periods />,
      path: 'periods',
    },
  ];

  const setUpTabs = async () => {
    const newReportTabs: any = [...reportsTabs];
    let startValueDefault = 0;
    startValueDefault = newReportTabs.findIndex((x: any) => x.path === subPage);
    setCompanyTabs(newReportTabs);
    setStartValue(startValueDefault === -1 ? 0 : startValueDefault);
    setLoading(false);
  };

  useEffect(() => {
    setUpTabs();
  }, []);

  if (loading) return <CenteredCircularProgress type="layout" />;
  return (
    <div>
      <div>
        <EnhancedTab
          startValue={startValue}
          tabs={companyTabs}
          onTabChange={handleNavigation}
        />
      </div>
    </div>
  );
};

export default Accounting;
